export default "__VITE_PUBLIC_ASSET__31f4003e__"